import HeadroomCore from 'headroom.js';
import Breakpoints from './Breakpoints';
import { offsets, units } from '../../config';

// Headroom settings
const settings = {
  // scroll tolerance in px before state changes
  tolerance: 5, // or {down: 0, up: 0},
  // css classes to apply
  classes: {
    // when element is initialised
    initial: 'headroom',
    // when scrolling up
    pinned: 'locked',
    // when scrolling down
    unpinned: 'unlocked',
    // when above offset
    top: 'top',
    // when below offset
    notTop: 'not-top',
    // when at bottom of scoll area
    bottom: 'bottom',
    // when not at bottom of scroll area
    notBottom: 'not-bottom',
  },
  // callback when pinned, `this` is headroom object
  onPin() {},
  // callback when unpinned, `this` is headroom object
  onUnpin() {},
  // callback when above offset, `this` is headroom object
  onTop() {},
  // callback when below offset, `this` is headroom object
  onNotTop() {},
  // callback at bottom of page, `this` is headroom object
  onBottom() {},
  // callback when moving away from bottom of page, `this` is headroom object
  onNotBottom() {},
};

export default class Headroom {
  constructor(element) {
    this.element = element;
    this.offsets = offsets;
    this.offsetUnit = units.offset;
    this.headroom = this.build();
    Breakpoints.on('change', this.rebuild.bind(this));
    this.headroom.init();
  }

  // Create a new Headroom instance
  build() {
    const options = settings;
    options.offset = this.currentOffset;
    return new HeadroomCore(this.element, options);
  }

  // Rebuild existing Headroom instance with updated offset.
  rebuild() {
    this.headroom.destroy();
    this.headroom.offset = this.currentOffset;
    this.headroom.init();
  }

  get currentOffset() {
    let currentBreakpoint = this.offsets[Breakpoints.current().name];
    // We're making the assumption that the root font size is being set on the html element.
    // Also, we're only making an exception for the alternate unit, `rem` at the moment.
    if (this.offsetUnit === 'rem') {
      const html = document.querySelector('html');
      const multiplier = window.getComputedStyle(html, null).getPropertyValue('font-size').replace('px', '');
      currentBreakpoint *= multiplier;
    }
    return currentBreakpoint;
  }
}
